import React from 'react';
import { GenericPermissionErrorPageAsync } from '@atlassian/jira-error-pages/src/async.tsx';
import { DocumentTitle } from '@atlassian/jira-global-document-title';
import { useIntl } from '@atlassian/jira-intl';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import messages from './jsw-config-header/messages';
import { JswConfigurationContent } from './main';

export const ProductsJswConfiguration = () => {
	const tenantContext = useTenantContext();
	const { formatMessage } = useIntl();

	if (!tenantContext.isAdmin) {
		return <GenericPermissionErrorPageAsync />;
	}

	return (
		<ContextualAnalyticsData sourceName="productsJswConfiguration" sourceType={SCREEN}>
			<DocumentTitle title={formatMessage(messages.jswConfigHeaderSpork)} />

			<PageLayout>
				<JswConfigurationContent />
			</PageLayout>
			<FireScreenAnalytics />
		</ContextualAnalyticsData>
	);
};
